import React, { Component } from 'react';
import DateFormatResolver, { fullDateUsFormat } from 'resolvers/date-format.resolver';
import useAlertCodeHandler from 'hooks/useAlertCodeHandler';

// @material-ui/core components
import withStyles from '@material-ui/core/styles/withStyles';
import Button from 'components/CustomButtons/Button';

const styles = {
	wrapper: {
		padding: 15,
		marginTop: 20,
		color: '#fff',
		backgroundColor: '#faa21a',
		boxShadow: '0 4px 20px 0 rgba(0, 0, 0, 0.14)',
		borderRadius: 3,
		display: 'flex',
		justifyContent: 'space-between',
		"@media (max-width: 768px)": {
			display: 'block',
		},
	},
	wrapperRead: {
		backgroundColor: '#999',
	},
	date: {
		margin: '10px 0 0 30px',
		"@media (max-width: 768px)": {
			marginLeft: 0,
		},
	},
	right: {
		display: 'flex',
		justifyContent: 'flex-end',
		"@media (max-width: 768px)": {
			flexWrap: 'wrap',
		},
	},
	buttonWrapper: {
		textAlign: 'right',
		minWidth: 130,
	},
	button: {
		padding: '8px 10px',
		fontSize: 11,
		border: '1px solid #fff',
		backgroundColor: 'transparent',
		'&:hover, &:active, &:focus': {
			backgroundColor: 'transparent',
		},
	},
	codeHandler: {
		textDecoration: 'underline',
		cursor: 'pointer',
		marginLeft: '10px',
	},
};

function ProvideCodeHandler({ children }) {
	const { resolveAlertLink, resolveAlertLinkText, resolveAlertMessage } = useAlertCodeHandler();
	return children(resolveAlertLink, resolveAlertLinkText, resolveAlertMessage);
}

class AlertsItem extends Component {
	render() {
		const {
			classes,
			id,
			createdAt,
			isRead,
			text,
			code,
			markAlert,
			isLoading,
			payload,
		} = this.props;

		const wrapperClasses = isRead
			? classes.wrapper + ' ' + classes.wrapperRead
			: classes.wrapper;

		return (
			<ProvideCodeHandler>
				{(resolveAlertLink, resolveAlertLinkText, resolveAlertMessage) => {
					return (
						<div className={wrapperClasses}>
							<div>
								{resolveAlertMessage(code, text, payload)}
								<span
									className={classes.codeHandler}
									onClick={() => resolveAlertLink({ code, payload })}
								>
									{resolveAlertLinkText(code)}
								</span>
							</div>
							<div className={classes.right}>
								<div className={classes.date}>
									{DateFormatResolver.resolve(createdAt, fullDateUsFormat)}
								</div>
								<div className={classes.buttonWrapper}>
									<Button
										disabled={isLoading}
										onClick={() => markAlert(id, !isRead)}
										className={classes.button}
									>
										{isRead ? 'Mark as unread' : 'Mark as read'}
									</Button>
								</div>
							</div>
						</div>
					)
				}}
			</ProvideCodeHandler>
		);
	}
}

export default withStyles(styles)(AlertsItem);
